import React from 'react';
import treeStyles from '@dtsl/css-tree-view/dist/index.module.css';
import { Skeleton } from '@dtsl/react/dist/components/Skeleton';
const SkeletonLoader = () => {
  return /*#__PURE__*/React.createElement("div", {
    "data-naos-element": "explorer-skeleton",
    className: treeStyles['sib-tree-view__exp-skeleton']
  }, /*#__PURE__*/React.createElement(Skeleton, {
    height: 24,
    width: "75%"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    height: 24,
    width: "40%"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    height: 24,
    width: "90%"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    height: 24,
    width: "65%"
  }));
};
export default SkeletonLoader;